var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import moment from 'moment';
import { toYuan } from '../../utils/unit-conversion';
export default Vue.extend({
    name: 'guaranteeSlipDetail',
    props: {
        propData: {
            type: Object,
            default: function () {
                return {};
            },
        },
    },
    computed: {
        startTime: function () {
            return moment(this.detailData.insuranceBeginTime).format('YYYY-MM-DD');
        },
        endTime: function () {
            return moment(this.detailData.insuranceEndTime).format('YYYY-MM-DD');
        },
        vehicleOwnerCertificateType: function () {
            return this.certChange(this.detailData.vehicleOwnerCertificateType);
        },
        insuredCertification: function () {
            return this.certChange(this.detailData.insuredCertification);
        },
        applicantCertification: function () {
            return this.certChange(this.detailData.applicantCertification);
        },
        policyType: function () {
            var typeCompare = {
                COMMERCIAL: '商业险',
                COMPULSORY: '交强险',
            };
            return typeCompare[this.detailData.policyType];
        },
        carStatus: function () {
            return this.detailData.isNewCar ? '新车' : '旧车';
        },
    },
    data: function () {
        return {
            isShowDialog: true,
            detailData: {},
            showMation: false,
        };
    },
    created: function () {
        this.propData.isShowDetail && this.getDetail(this.propData.id);
    },
    methods: {
        emitFlag: function (value) {
            this.$emit('close-details', false);
        },
        getDetail: function (id) {
            var _this = this;
            var param = this.propData.data;
            this.$request({
                method: this.propData.method ? this.propData.method : 'get',
                url: this.propData.url,
                data: __assign({}, param),
            }).then(function (res) {
                if (!res) {
                    return;
                }
                if (!res.errorCode) {
                    _this.detailData = res.data;
                    _this.showMation = true;
                }
            });
        },
        changeYuan: function (value) {
            return toYuan(value).toFixed(2);
        },
        certChange: function (value) {
            var typeChange = {
                N: '其他',
                I: '身份证',
                TY: '统一社会信用代码',
                P: '护照',
            };
            return typeChange[value];
        },
    },
});
